module.exports = __webpack_public_path__ + "static/img/zt1-pic9.662c564.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/zt1-pic9.jpg
// module id = vgYj
// module chunks = 171